import { useSearchParams } from 'react-router-dom';

export function useOrderParams(): {
  mode: 'careerHighlights' | 'selectedWork';
  resourceId: string;
  setResourceId: (id?: string)=> void;
} {
  const [sp, setSp] = useSearchParams();

  const mode = sp.get('mode') === 'careerHighlights' ? 'careerHighlights' : 'selectedWork';
  const resourceId = sp.get('resourceId') ?? '';

  const setResourceId = (id?: string): void => {
    const next = new URLSearchParams(sp);
    if (id) next.set('resourceId', id);
    else next.delete('resourceId');
    setSp(next, { replace: true });
  };

  return { mode, resourceId, setResourceId };
}
